import type { ConflictInfo } from './condense-changes.helpers';
import type { Baseline } from '@shared/models/project.model';
import type { IProposal } from '@shared/models/proposals.model';

/**
 * Logs proposal action condensation conflicts for developer visibility.
 * Overlapping edits on the same slot keep the later change only; this is expected
 * during resolution and must not be shown as an end-user warning.
 */
export const warnProposalCondenseConflicts = (
  version: Baseline,
  proposal: IProposal,
  conflicts: ConflictInfo[],
): void => {
  if (conflicts.length === 0) return;

  console.warn(
    `[nodon proposals] Proposal "${proposal.name}" (${proposal.id}): ` +
      `${conflicts.length} change conflict(s) while condensing actions for version "${version.id}". ` +
      'Overlapping edits to the same slot kept the later change only; proposal results may not reflect every action.',
    {
      versionId: version.id,
      proposalId: proposal.id,
      conflicts: conflicts.map(
        ({ elementId, changeType, reason, keptChange, discardedChange }) => ({
          elementId,
          changeType,
          reason,
          keptChangeType: keptChange.type,
          discardedChangeType: discardedChange.type,
        }),
      ),
    },
  );
};
